import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCode,
  faPalette,
  faMobileAlt,
  faRocket,
  faRobot,
  faCogs,
} from '@fortawesome/free-solid-svg-icons';

const services = [
  {
    title: 'Webentwicklung',
    description: 'Maßgeschneiderte Websites mit modernsten Technologien.',
    icon: faCode,
  },
  {
    title: 'UI/UX Design',
    description: 'Ästhetisches, benutzerzentriertes Design für deine Marke.',
    icon: faPalette,
  },
  {
    title: 'Mobile App Entwicklung',
    description: 'Nahtlose Mobile-Apps für iOS & Android.',
    icon: faMobileAlt,
  },
  {
    title: 'Digitale Strategie',
    description: 'Wir analysieren und planen deinen digitalen Erfolg.',
    icon: faRocket,
  },
  {
    title: 'AI-Integration',
    description: 'Smartere Systeme durch KI-Lösungen – ready für die Zukunft.',
    icon: faRobot,
  },
  {
    title: 'Systemintegration & DevOps',
    description: 'Stabile & skalierbare Systeme mit Automatisierung.',
    icon: faCogs,
  },
];

const Services = () => {
  return (
    <div className="bg-gradient-to-b from-black via-gray-900 to-black text-white min-h-screen py-24 px-6 relative">
      {/* Decorative Background Element (Optional) */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-fuchsia-700/5 via-black to-black"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <h2 className="text-5xl font-extrabold text-center mb-16 text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-400 to-pink-600">
          Unsere Leistungen
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white/5 border border-gray-700 p-8 rounded-2xl shadow-xl hover:border-fuchsia-500 hover:shadow-fuchsia-800/20 transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="flex items-center justify-center w-16 h-16 mb-6 mx-auto rounded-full bg-gradient-to-br from-fuchsia-600 to-pink-600 text-white text-3xl shadow-md group-hover:scale-110 transition">
                <FontAwesomeIcon icon={service.icon} />
              </div>
              <h3 className="text-xl font-bold text-center mb-3 text-white">{service.title}</h3>
              <p className="text-gray-400 text-sm text-center">{service.description}</p>
              <div className="absolute inset-0 rounded-2xl border border-transparent group-hover:border-fuchsia-500 transition-all duration-300 pointer-events-none" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
